// Small helpers for localStorage-backed features:
// - Recently viewed products
// - Order history (mirrored client-side after successful checkout)

import { getProductImage as getProductImageFn } from "./categoryImages";

const RECENT_KEY = "brokeshopping.recent.v1";
const ORDERS_KEY = "brokeshopping.orders.v1";

const RECENT_CAP = 12;
const ORDERS_CAP = 20;

function safeGet(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function safeSet(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore */
  }
}

// ---------- Recently viewed ---------- //

export function getRecent() {
  return safeGet(RECENT_KEY);
}

export function trackRecent(product) {
  if (!product?.id) return;
  const snapshot = {
    id: product.id,
    title: product.title,
    price: product.price,
    image: getProductImageFn(product),
    category: product.category,
    categoryLabel: product.categoryLabel,
    rating: product.rating,
    reviewCount: product.reviewCount,
    viewedAt: Date.now(),
  };
  const current = getRecent().filter((p) => p.id !== product.id);
  current.unshift(snapshot);
  safeSet(RECENT_KEY, current.slice(0, RECENT_CAP));
}

// ---------- Order history ---------- //

export function getOrders() {
  return safeGet(ORDERS_KEY);
}

export function saveOrder(order) {
  if (!order?.orderNumber) return;
  const snapshot = {
    orderNumber: order.orderNumber,
    total: order.total,
    itemCount: (order.items || []).reduce((s, i) => s + i.quantity, 0),
    firstImage: order.items?.[0]?.image || null,
    createdAt: order.createdAt || new Date().toISOString(),
  };
  const current = getOrders().filter((o) => o.orderNumber !== order.orderNumber);
  current.unshift(snapshot);
  safeSet(ORDERS_KEY, current.slice(0, ORDERS_CAP));
}

// ---------- Multi-image gallery derivation ---------- //
// Delegated to lib/categoryImages so all images stay category-appropriate.
export { getProductImage, getProductImages } from "./categoryImages";
